module.exports = __webpack_public_path__ + "img/text-icon.c75ae2e3.svg";